export const DEFAULT_DATE_FORMAT = 'dd.MM.yyyy';

// The OVO code of Digitaal Vlaanderen, the organisation that owns the product groups.
export const OVO_DIGITAAL_VLAANDEREN = 'OVO002949';
